module.exports = __webpack_public_path__ + "assets/img/ebt965p.5e95d2fd.png";